import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { IArticleRelatedPost } from 'shared/atoms';
import { PromiseOrValue } from 'shared/utils/promise-or-value';

export const $CurrentArticleRelatedPost = atom({} as PromiseOrValue<IArticleRelatedPost>);
export const $CurrentArticleLoadableRelatedPost = loadable($CurrentArticleRelatedPost);
